import React from 'react';
import { Chip } from '@mui/material';
import { CheckCircleOutline, HourglassEmpty, Cancel as CancelIcon } from '@mui/icons-material';

interface TicketApprovalStatusChipProps {
  status?: string | null;
}

const TicketApprovalStatusChip: React.FC<TicketApprovalStatusChipProps> = ({ status }) => {
  switch (status) {
    case 'Pending':
      return <Chip size="small" color="info" icon={<HourglassEmpty />} label="Pending Approval" />;
    case 'Approved':
      return <Chip size="small" color="success" icon={<CheckCircleOutline />} label="Approved" />;
    case 'Rejected':
      return <Chip size="small" color="error" icon={<CancelIcon />} label="Rejected" />;
    default:
      return null;
  }
};

export default TicketApprovalStatusChip;
